/* FUSFIT POINTS · cálculo puro compartido por assets/ff-puntos.js (ficha, carrito) y assets/ff-escalera.js (escalón por
   monto). Es la MISMA cuenta que apps/fusadmin-web/src/lib/puntos/estimado-pura.ts (puntosEstimados / multiplicadorEstimado
   / multiplicadorTienda) y que el motor (reglas-pura.ts): la paridad se prueba con node --test en
   shopify_theme/borrador-carrito-puntos-188360589348/_pruebas/paridad-puntos.test.mjs.
   - multiplicador = el mayor evento vigente a la hora de Caracas + porMonto.extra si la base llega a porMonto.desde;
   - puntos = floor(centavos × compra×100 × multiplicador×100 / 1e6);
   - baseCarrito(cart de /cart.js) = la base del motor (baseEnBs): lo que vale el carrito con todos sus descuentos MENOS el
     de divisas (que el motor devuelve). Los cupones de pedido (afiliado…) y los canjes sí restan.
   - dudaCarrito(cart) = 1 céntimo si hubo descuento de divisas: el motor lo reconstruye redondeando (sub × % ÷ (100 − %))
     y puede quedar 1 céntimo por debajo. estimar(base, r, ahora, duda) decide el extra por monto con base − duda: justo
     en el borde de $200, el carrito nunca dice ×2 cuando el motor daría ×1 (en caso de duda, ×1).
   Sin DOM ni red. En el navegador queda en window.ffPuntosCalculo; en node, module.exports. */
(function (raiz) {
  var CARACAS_MS = 4 * 3600000;
  function multEvento(ahoraMs, eventos) {
    var c = new Date(ahoraMs - CARACAS_MS), dia = c.getUTCDate(), mes = c.getUTCMonth() + 1, mejor = 1, fusfitDay = false;
    (eventos || []).forEach(function (e) {
      var aplica = e.tipo === 'rango' ? e.inicioMs != null && e.finMs != null && ahoraMs >= e.inicioMs && ahoraMs <= e.finMs
        : e.dia === dia && (e.mes == null || e.mes === mes);
      if (aplica && e.multiplicador > mejor) { mejor = e.multiplicador; fusfitDay = e.tipo === 'dia_mes' && e.dia === 13; }
    });
    return { m: mejor, fusfitDay: fusfitDay };
  }
  function porMontoVigente(r) {
    var pm = r && r.porMonto;
    return pm && Number(pm.desde) > 0 && Number(pm.extra) > 0 ? pm : null;
  }
  /** baseCents: base en centavos. r: reglas tal como las publica el ERP ({ganar:{compra}, eventos, porMonto}). */
  function estimar(baseCents, r, ahoraMs, dudaCents) {
    var ev = multEvento(ahoraMs, r && r.eventos), pm = porMontoVigente(r);
    var base = Math.max(0, Math.round(Number(baseCents) || 0));
    var llega = !!pm && base - (Math.round(Number(dudaCents) || 0)) >= Math.round(pm.desde * 100);
    var m = ev.m + (llega ? Number(pm.extra) : 0);
    var compra = Number(r && r.ganar && r.ganar.compra) || 0;
    return { n: Math.floor((base * Math.round(compra * 100) * Math.round(m * 100)) / 1e6), m: m, evento: ev, llega: llega, pm: pm };
  }
  /** Títulos EXACTOS de la Function de divisas (fusfit-divisas-order-discount-js: `Beneficio por pago en ${label}`). */
  var TITULOS_DIVISAS = ['Beneficio por pago en Zelle', 'Beneficio por pago en USD / divisas'];
  function esDivisas(app) { return TITULOS_DIVISAS.indexOf(String((app && app.title) || '').trim()) >= 0; }
  /** Base del motor para un carrito de /cart.js, en centavos: total con todos los descuentos + lo descontado por divisas. */
  function baseCarrito(cart) {
    var devuelto = 0;
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (a) { if (esDivisas(a)) devuelto += Number(a.total_allocated_amount) || 0; });
    return Math.max(0, (Number(cart && cart.total_price) || 0) + devuelto);
  }
  function dudaCarrito(cart) {
    return ((cart && cart.cart_level_discount_applications) || []).some(function (a) { return esDivisas(a) && Number(a.total_allocated_amount) > 0; }) ? 1 : 0;
  }
  var api = { TITULOS_DIVISAS: TITULOS_DIVISAS, multEvento: multEvento, porMontoVigente: porMontoVigente, estimar: estimar, esDivisas: esDivisas, baseCarrito: baseCarrito, dudaCarrito: dudaCarrito };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (raiz && !raiz.ffPuntosCalculo) raiz.ffPuntosCalculo = api;
})(typeof window !== 'undefined' ? window : this);
